


















































































































































/* General */
import Vue from 'vue'
import { Location } from 'vue-router'

/* Mixins */

/* Components */
import { HomeTableProps } from '@/components/listing/home-table/home-table.constants'
import PersonAvatar from '@/components/global/avatar.vue'
import DdCheckbox from '@/components/global/dd-checkbox.vue'

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import { IHomeTableItem } from '@/types/data-objects/items'
import { EEntities } from '@/types'
import { IJobAppointee, IPersonWithEmail } from '@/api/types/response.types'

export default Vue.extend({
  name: 'HomeTableDesktop',

  components: {
    PersonAvatar,
    DdCheckbox,
  },

  props: {
    ...HomeTableProps,
  },

  data() {
    return {
      RouteAssistant,
      selectAll: false,
      rowSelections: [] as Array<boolean>,

      normalAvatarSize: 32,
      smallAvatarSize: 24,
    }
  },

  computed: {
    itemName(): string {
      return TextAssistant.itemSingularName(this.type)
    },
    isMailbox(): boolean {
      return this.type === EEntities.MAILBOXES
    },
    anySelected(): boolean {
      return this.rowSelections.some(r => r)
    },
  },

  watch: {
    tableData: {
      immediate: false,
      handler(val: IHomeTableItem[]) {
        this.rowSelections = Array<boolean>(val.length)
        this.clearBulkEdit()
      },
    },
  },

  methods: {
    /* If an item were moved from another entity with jobs and the mandates didn't map, we could be out of sync here (which is fine)*/
    isJobMandatedAssigneeActuallyTheAssignee(
      item: IHomeTableItem,
      j: IJobAppointee,
    ) {
      return (
        item.jobIDMandatedAsAssignee === j.job.id &&
        ((item.assignedTo === null && j.appointee === null) ||
          (item.assignedTo !== null &&
            j.appointee !== null &&
            item.assignedTo.id === j.appointee.id))
      )
    },
    getCustomerNameAndEmail(person: IPersonWithEmail) {
      if (person.name === person.email) {
        return person.email
      }
      return `${person.name} <${person.email}>`
    },
    clearBulkEdit() {
      this.selectAll = false
      this.handleSelectAll(false)
    },
    getColSpanForHeader() {
      return this.isMailbox ? 8 : 7
    },
    broadcastBulkEditSelection() {
      const selectedIDs = Array<number>()
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.rowSelections[i]) {
          selectedIDs.push(this.tableData[i].id)
        }
      }
      this.$emit('selected-rows', selectedIDs)
    },
    getRowClass(index: number): string {
      if (this.anySelected) {
        if (this.isMailbox) {
          if (this.rowSelections[index]) {
            return 'mailbox selected'
          } else {
            return 'mailbox unselected'
          }
        } else {
          if (this.rowSelections[index]) {
            return 'selected'
          } else {
            return 'unselected'
          }
        }
      }
      return ''
    },
    handleSelect() {
      this.selectAll = !this.rowSelections.some(r => !r)
      this.broadcastBulkEditSelection()
    },
    handleSelectAll(selected: any) {
      const newRowSelections = Array<boolean>(this.rowSelections.length)
      for (let i = 0; i < this.rowSelections.length; i++) {
        newRowSelections[i] = selected
      }
      this.rowSelections = newRowSelections
      this.broadcastBulkEditSelection()
    },
    getDetailRouterLink(row: IHomeTableItem): Location {
      if (this.isMailbox) {
        return RouteAssistant.getConversationRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      } else {
        return RouteAssistant.getTaskRoute(
          this.$route.params.accountId,
          row.parent.id,
          row.id.toString(),
          this.$permissions,
          row.parent.name,
          row.refNumber,
          row.title,
          null,
          this.fromAll,
          this.fromEntityHome,
        )
      }
    },
    getLandingRouterLink(row: IHomeTableItem): Location {
      const entityID = row.parent.id

      if (this.isMailbox) {
        return RouteAssistant.getMailboxRoute(
          this.$route.params.accountId,
          entityID,
        )
      } else {
        return RouteAssistant.getProjectLandingRoute(
          this.$route.params.accountId,
          entityID,
          this.$permissions,
        )
      }
    },
    hasCounts(item: IHomeTableItem): boolean {
      return (
        this.hasLinkedTasks(item) ||
        this.hasLinkedConversations(item) ||
        this.hasThreadCount(item) ||
        this.hasChecklistCount(item)
      )
    },
    hasLinkedTasks(item: IHomeTableItem): boolean {
      return item.linkedTasksCount > 0
    },
    hasLinkedConversations(item: IHomeTableItem): boolean {
      return item.linkedConversationsCount && item.linkedConversationsCount > 0
    },
    hasThreadCount(item: IHomeTableItem): boolean {
      return item.threadCount > 0
    },
    hasChecklistCount(item: IHomeTableItem): boolean {
      return item.totalChecklistItemsCount > item.completedChecklistItemsCount
    },
    hasDesc(item: IHomeTableItem): boolean {
      return item.text && item.text.length > 0
    },
    getItemInfoClass(item: IHomeTableItem): string {
      const hasDesc = this.hasDesc(item)
      if (this.fromAll) {
        return hasDesc ? 'three-lines' : 'two-lines'
      }
      return hasDesc ? 'two-lines' : 'one-line'
    },
    getItemInfoColSpan(item: IHomeTableItem) {
      let result = 1
      if (!item.dueDate) {
        result++
      }
      if (!this.hasCounts(item)) {
        result++
      }
      return result
    },
  },
})
